(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Items', Items);

    Items.$inject = ['$resource'];

    function Items ($resource) {
        var resourceUrl =  'api/items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                    params: {
                        id: 'getPage'
                    },
            },
            'getAll': { method: 'GET', isArray: true,
                    params: {
                        id: 'getAll'
                    },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET'}
        });
    }
})();
